export default __webpack_public_path__ + "static/media/ChuckRoast.a9475bdb.png";